module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-topup"
  }, [_c('ActionBar', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Top Ups")])]), _c('base-list', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "resultsPerPage": 5,
      "componentType": "client-invoices"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aca4cd6c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/ClientTopUps.vue
// module id = 2661
// module chunks = 1